import { validateArray } from '../../utils/validate'
import { H3 } from '../../components/Text'

export const TableManagement = ({
  header,
  data,
  TextEmptyList = 'Lista vacía',
  isLarge = false
}) => {

  return (
    <div className={`relative overflow-x-auto h-auto ${isLarge ? 'max-h-[650px]' : 'max-h-96'} h-fit p-1 overflow-y-auto border border-gray-400 rounded-lg`}>
      <table className="w-full text-sm text-left text-gray-500">
        <thead className="text-xs uppercase bg-gray-50 sticky top-0">
          <tr>
            <th
              scope="col"
              className="p-1 bg-[#6189ca] text-white whitespace-nowrap"
            >
              #
            </th>
            {header?.map((head, index) => (
              <th
                scope="col"
                className="p-2 bg-[#5f88c8] text-white whitespace-nowrap"
                key={index}
              >
                {head?.label}
              </th>
            ))}
          </tr>
        </thead>
        {validateArray(data) ? (
          <tbody>
            {data?.map((item, index) => (
              <tr className="bg-white border-b border-[#5f88c870]" key={index}>
                <th
                  scope="row"
                  className={`p-1 text-gray-800 whitespace-pre-wrap overflow-auto text-right font-semibold`}
                >
                  {index + 1}
                </th>
                {header?.map((head, idy) => (
                  head.type !== 'action' ?
                    <th
                      key={idy}
                      scope="row"
                      className={`p-2 text-gray-800 whitespace-pre-wrap overflow-auto ${head?.isNumber ? 'text-right' : ''} ${head?.aditionalClass || 'font-semibold'}`}
                    >
                      {item[head?.name]}
                    </th>
                    :
                    <th
                      key={idy}
                      scope="row"
                      className={`p-2 text-gray-800 whitespace-pre-wrap overflow-auto ${head?.isNumber ? 'text-right' : ''} ${head?.aditionalClass || 'font-semibold'}`}
                    >
                      {head.actions?.map((ix, ind) => (
                        <button
                          type='button'
                          onClick={() => ix.action(item)}
                          key={ind}
                        >
                          <i className={`${ix.icon} text-red-500 text-lg`} />
                        </button>
                      ))}
                    </th>
                ))}
              </tr>
            ))}
            <tr className="bg-white">
              <th></th>
              {header?.map((head, idy) => (
                <th
                  key={idy}
                  scope="row"
                  className={`px-2 text-gray-800 whitespace-pre-wrap overflow-auto ${head?.isNumber ? 'text-right' : ''} ${head?.aditionalClass || 'font-semibold'}`}
                >
                  {
                    head.makeTotal ? data.reduce((acc, curr) => acc + parseFloat(curr[head.name] || 0), 0)?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : ''
                  }
                  {
                    head.makeTotalPercentage ? '100 %' : ''
                  }
                  {
                    !head.makeTotal && !head.makeTotalPercentage ? 'Total' : ''
                  }
                </th>
              ))}
            </tr>
          </tbody>
        ) : null}
      </table>
      {!validateArray(data) && (
        <div className="px-6 py-3 bg-[#ffeadd3e] text-gray-800">
          <H3>{TextEmptyList}</H3>
        </div>
      )}
    </div>
  )
}
